import { useEffect, useState } from 'react';
import api from '../config/api';

const API_BASE = process.env.REACT_APP_API_URL || 'https://api.superchargeme.com';

/**
 * Activity timeline for any audited entity. Routes are mounted in the
 * audit_log middleware as `${module}_route` (e.g. procurement_purchase_orders_route).
 * Detail pages pass their own entity_type to render an actor + action + timestamp rail.
 */
export const getEntityTimeline = async (entityType, entityId) => {
  const response = await api.get(`${API_BASE}/api/audit-log/timeline/${entityType}/${entityId}`);
  return response.data;
};

/**
 * React hook flavor — handles loading + null-id case so detail pages stay terse.
 *   const { events, loading } = useEntityTimeline('procurement_purchase_orders_route', poId);
 */
export function useEntityTimeline(entityType, entityId) {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!entityType || !entityId) { setEvents([]); return; }
    let cancelled = false;
    setLoading(true);
    getEntityTimeline(entityType, entityId)
      .then(res => { if (!cancelled) setEvents(res?.data || []); })
      .catch(() => { if (!cancelled) setEvents([]); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [entityType, entityId]);
  return { events, loading };
}
